import React from "react";
import { Container, Box, Tab, Tabs } from "@material-ui/core";

class AuthTabs extends React.Component {
  render() {
    const tabValueMapping = {
      signIn: "signIn",
      forgotPassword: "signIn",
      signUp: "signUp",
      confirmSignUp: "signUp"
    };

    return (
      <>
        <Tabs
          value={tabValueMapping[this.props.authState]}
          onChange={(e, tabValue) => {
            this.props.onTabChange(tabValue);
          }}
          indicatorColor="primary"
          centered
        >
          <Tab value="signIn" label="Log In" />
          <Tab value="signUp" label="Register" />
        </Tabs>

        <Container maxWidth="xs">
          <Box my={2}>{this.props.children}</Box>
        </Container>
      </>
    );
  }
}

export default AuthTabs;
